import React, { Component } from 'react';
import PropTypes from 'prop-types';
import DefaultCartButton from 'components/CartButton/DefaultCartButton';
import { getEnvironment } from 'utils/Window';

class CffpCartButton extends Component {
  constructor() {
    super();

    this.state = { loaded: false };
  }

  componentDidMount() {
    // This is required to keep the wrong action on the form from appearing when rendered on the server.
    this.setState({ loaded: true }); // eslint-disable-line react/no-did-mount-set-state
  }

  render() {
    const {
      subType,
      title,
      rightIcon,
      leftIcon,
      disabled,
      isCallToPurchase,
      callToPurchaseHandler,
      callToPurchasePage,
      callToPurchasePhoneNumber,
      addToCartHandler,
      productId,
      continueShoppingHref,
    } = this.props;
    const { loaded } = this.state;

    const env = getEnvironment();
    let prefix = 'www';

    if (env !== 'production') {
      prefix = env === 'localhost' ? 'www-dev' : `www-${env}`;
    }

    const cffpCartPath = `//${prefix}.cffp.edu/cart/`;

    return (
      <form action={loaded ? cffpCartPath : undefined} method='POST'>
        <input name='productId' aria-label={productId} value={productId} hidden readOnly />
        <input name='continueShoppingUrl' aria-label='Continue Shopping' value={continueShoppingHref} hidden readOnly />
        <DefaultCartButton
          actionType='submit'
          subType={subType}
          title={title}
          rightIcon={rightIcon}
          leftIcon={leftIcon}
          disabled={disabled}
          isCallToPurchase={isCallToPurchase}
          callToPurchaseHandler={callToPurchaseHandler}
          callToPurchasePage={callToPurchasePage}
          callToPurchasePhoneNumber={callToPurchasePhoneNumber}
          addToCartHandler={() => addToCartHandler()}
        />
      </form>
    );
  }
}

CffpCartButton.propTypes = {
  subType: PropTypes.string,
  title: PropTypes.string,
  rightIcon: PropTypes.string,
  leftIcon: PropTypes.string,
  disabled: PropTypes.bool,
  isCallToPurchase: PropTypes.bool,
  callToPurchasePage: PropTypes.string,
  callToPurchasePhoneNumber: PropTypes.string,
  callToPurchaseHandler: PropTypes.func,
  addToCartHandler: PropTypes.func,
  productId: PropTypes.number,
  continueShoppingHref: PropTypes.string,
};

export default CffpCartButton;
